import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApproved, getArmado } from "../../redux/actions/actionDocument";
import ProduccionCard from "./produccionCard";
import ArmadoCard from "./armadoCard";

export default function Produccion() {
  const dispatch = useDispatch();
  const approved = useSelector((state) => state.documents.documentsApproved);
  const armado = useSelector((state) => state.documents.documentsArmado);
  const [aEntregar, setAEntregar] = useState([]);
  const cloneApproved = structuredClone(approved);
  const dragItem = useRef();

  useEffect(() => {
    dispatch(getApproved());
    dispatch(getArmado());
  }, [dispatch]);

  console.log(approved)
  console.log(armado)

  
  return (
    <div className="container flex flex-row">
      <div className="w-1/2 border-black border-2">
        <h1 className="pt-2">Pedidos</h1>
        <div>
            <div className="flex flex-row text-[9pt] font-bold py-2 ">
                <div className="w-14 text-center">N° Doc</div>
                <div className="w-60 pl-2">Cliente</div>
                <div className="w-24 text-center">Salida</div>
                <div className="w-24 text-center">Regreso</div>
                <div className="w-14"></div>
            </div>
          <div>
            {approved.map((item, index) => {
              return (
                <div key={item._id} className="flex flex-row">
                  <ProduccionCard
                    id={item._id}
                    numberDocument={item.numberDocument}
                    clientName={item.client_id.name}
                    dateSend={item.dateSend}
                    dateReception={item.dateReception}
                  />                  
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="w-1/2 border-black border-2">
        <div>Pedidos Armados</div>
        <div>
            <div className="flex flex-row text-[9pt] font-bold py-2 ">
                <div className="w-14 text-center">N° Doc</div>
                <div className="w-60 pl-2">Cliente</div>
                <div className="w-24 text-center">Salida</div>
                <div className="w-24 text-center">Regreso</div>
                <div className="w-14"></div>
            </div>
          <div>
            {armado.map((item, index) => {
              return (
                <div key={item._id} className="flex flex-row">
                  <ArmadoCard
                    id={item._id}
                    numberDocument={item.numberDocument}
                    clientName={item.client_id.name}
                    dateSend={item.dateSend}
                    dateReception={item.dateReception}
                  />                  
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
